import React from 'react';
import { FaLaptopCode } from 'react-icons/fa';

const experiences = [
    {
        company: 'Axios Softwork',
        duration: '04/2025 - 07/2025 (3 month)',
        logo: '/images/axios-logo.png',
        description:
            'Internship focused on modern frontend development, UI design, and real-world feature implementation in production-level projects.',
        technologies: ['React.js', 'TypeScript', 'Tailwind CSS', 'Zustand', 'SCSS'],
        tasks: [
            'Contributed to the development of the Nivid App with a strong focus on modern UI and smooth user interactions.',
            'Built and maintained reusable components using React.js, TypeScript, and Zustand for state management.',
            'Regularly used GitLab for version control, actively handled merge conflicts, and participated in code reviews.',
            'Collaborated with the development team in an Agile environment while following best practices in frontend engineering.',
            'Improved debugging skills and wrote cleaner, more maintainable code by adopting modular component design.',
        ],
    },
];

const Experience = () => {
    return (
        <section id="experience" className="py-20 px-4 bg-bg text-text transition-colors duration-300">
            <div className="max-w-6xl mx-auto">
                <h1 className="text-3xl font-bold text-accent mb-10 text-center font-mono">
                    EXPERIENCE
                </h1>
                <div className="grid md:grid-cols-1 gap-10">
                    {experiences.map((exp, index) => (
                        <div
                            key={index}
                            className="bg-card border border-border rounded-xl p-6 hover:border-accent transition duration-300"
                        >
                            <div className="flex items-center mb-4">
                                <img
                                    src="/images/axios-logo.png"
                                    alt="Axios Softwork logo"
                                    className="w-12 h-12 rounded mr-4 border border-border bg-card p-1"
                                />

                                <div>
                                    <h4 className="text-2xl font-bold text-accent flex items-center">
                                        <FaLaptopCode className="mr-2" /> {exp.company}
                                    </h4>
                                    <p className="text-sm text-subtle-text">{exp.duration}</p>
                                </div>
                            </div>

                           
                            <p className="text-subtle-text mb-6">{exp.description}</p>

                            <div className="mb-6">
                                <p className="text-sm text-subtle-text mb-1">Technologies Used:</p>
                                <div className="flex flex-wrap gap-2">
                                    {exp.technologies.map((tech, idx) => (
                                        <span
                                            key={idx}
                                            className="px-3 py-1 bg-tag-bg text-sm text-tag-text rounded-full"
                                        >
                                            {tech}
                                        </span>
                                    ))}
                                </div>
                            </div>

                            <ul className="list-disc list-inside space-y-2 text-text">
                                {exp.tasks.map((task, idx) => (
                                    <li key={idx}>{task}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Experience;